import { Right } from './Right';
import { Left } from './Left';

const Create = [Left, Right];

export { Create as EventsCreateForm };
